import { render } from "./select-payment-method.vue?vue&type=template&id=a8e25674&scoped=true"
import script from "./select-payment-method.vue?vue&type=script&lang=js"
export * from "./select-payment-method.vue?vue&type=script&lang=js"

import "./select-payment-method.vue?vue&type=style&index=0&id=a8e25674&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e25674"]])

export default __exports__